module.exports = __webpack_public_path__ + "img/player_turn_003.e365a4d9.png";